import * as React from 'react'
import { useState } from 'react'
import type { JSX } from 'react'

import { FolderPlusIcon, Input } from '@buffer-mono/popcorn'

import styles from './CollectionNameEditor.module.css'

interface CollectionNameEditorProps {
  onSubmit: (name: string) => void
  onCancel: () => void
}

export function CollectionNameEditor({
  onSubmit,
  onCancel,
}: CollectionNameEditorProps): JSX.Element {
  const [name, setName] = useState('')
  const inputRef = React.useRef<HTMLInputElement>(null)
  const submittedRef = React.useRef(false)

  React.useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (e.key === 'Enter' && name.trim()) {
      submittedRef.current = true
      onSubmit(name.trim())
    } else if (e.key === 'Escape') {
      submittedRef.current = true
      onCancel()
    }
  }

  const handleBlur = (): void => {
    if (submittedRef.current) return
    if (name.trim()) {
      onSubmit(name.trim())
    } else {
      onCancel()
    }
  }

  return (
    <div className={styles.collectionEditorWrapper}>
      <Input
        ref={inputRef}
        value={name}
        size="small"
        onChange={(e): void => setName(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        prefix={<FolderPlusIcon size="small" />}
        placeholder="Collection name"
        className={styles.collectionInput}
      />
    </div>
  )
}
